import { PillItemProps } from "./model"

export const PillItem = (props: PillItemProps) => {
    return (
        <div className={`bg-figmaBlack rounded-[100px] h-fit px-[12px] py-[8px] ${props.classes}`} onClick={props.onClick}>
            <p className="text-white text-[14px]">{props.text}</p>
        </div>
    )
}

export const PillItemGrey = (props: PillItemProps) => {
    return (
        <div className={`bg-white border-2 border-figmaLightGray rounded-[100px] h-fit px-[12px] py-[8px] ${props.classes}`} onClick={props.onClick}>
            <p className="text-figmaBlack text-[14px]">{props.text}</p>
        </div>
    )
}